import React from "react";
import clsx from "clsx";
import { Card } from "@curves/ui-base";
import { Grid } from "@mui/material";
import { ReadTextField } from "@icoach/components";

const ReceiverSectionByRead = props => {
	const { titleClassName = "bg-light-active", sourceData = {} } = props;
	const { receiverName, receiverMobile, receiverPostCode = "", receiverAddress = "", receiverNotes } = sourceData;

	return (
		<React.Fragment>
			<Card.CardHeader title="收件人資訊" className={clsx("px-4", titleClassName)} />
			<Card.CardContent className="p-4">
				<Grid spacing={3} container>
					<Grid xs={4} item>
						<ReadTextField label="收件人">{receiverName}</ReadTextField>
					</Grid>
					<Grid xs={4} item>
						<ReadTextField label="收件手機">{receiverMobile}</ReadTextField>
					</Grid>
					<Grid xs={12} item>
						<ReadTextField label="收件地址">{`${receiverPostCode} ${receiverAddress}`}</ReadTextField>
					</Grid>
					<Grid xs={12} item>
						<ReadTextField label="備註">{receiverNotes}</ReadTextField>
					</Grid>
				</Grid>
			</Card.CardContent>
		</React.Fragment>
	);
};

export default ReceiverSectionByRead;
